import { IconInformationFill, IconSuccessFill } from '@saucelabs/ds-icons';
import { Typography } from '@saucelabs/ds-typography';
import React from 'react';
import Modal from '@saucelabs/ds-modal';
import { useDispatch } from 'react-redux';
import { modalActions, modalConnectV2 } from '@saucelabs/sl-container-modal';
import Button from '@saucelabs/ds-button';

import SauceIconForward from '../../images/sds-icons-big/sauce-icon-forward.svg';
import SauceIconHeart from '../../images/sds-icons-big/sauce-icon-heart.svg';
import { CREDITS_AUTO_TOPUP_MODAL } from '../../constants';

interface CreditsTopupModalProps {
  topupEnabled?: boolean
  enableTopupCallback: () => void
  disableTopupCallback: () => void
}

const SAUCE_IMAGE_AUTO_TOPUP_MODAL_CLASS = 'w-10 h-10 mb-2';

const InternalCreditsTopupModal: React.FC<CreditsTopupModalProps> = ({
  topupEnabled,
  disableTopupCallback,
  enableTopupCallback,
}) => {
  const dispatch = useDispatch();

  const hideModal = () => dispatch(modalActions.hideModal());

  const disableAutoTopup = () => {
    if (topupEnabled) disableTopupCallback();
    hideModal();
  };

  const enableAutoTopup = () => {
    if (!topupEnabled) enableTopupCallback();
    hideModal();
  };
  const title = `Credits auto-refill is ${topupEnabled ? 'enabled' : 'disabled'}`;
  const enableLabel = topupEnabled ? 'Keep Enabled' : 'Enable Auto-Refill';
  const disableLabel = topupEnabled ? 'Disable Credits-Refill' : 'Keep Disabled';
  const icon = topupEnabled ? (
    <IconSuccessFill className="fill-current text-green-600" />
  ) : (
    <IconInformationFill className="fill-current text-gray-500" />
  );

  return (
    <Modal
      data-qa="summary-tile-plan-auto-renew-modal"
      icon={icon}
      onHide={hideModal}
      title={title}
    >
      {!topupEnabled && (
        <Typography
          className="text-high-emphasis font-semibold"
        >
          By enabling auto-refill
        </Typography>
      )}
      <div className="grid grid-cols-2 mt-2 mb-4 gap-2">
        <div>
          <SauceIconForward className={SAUCE_IMAGE_AUTO_TOPUP_MODAL_CLASS} />
          <Typography className="text-high-emphasis font-semibold w-full">
            Your organization will always have credits to test
          </Typography>
        </div>
        <div>
          <SauceIconHeart className={SAUCE_IMAGE_AUTO_TOPUP_MODAL_CLASS} />
          <Typography className="text-high-emphasis font-semibold w-full">
            {"Your testing won't be disrupted due to lack of credits"}
          </Typography>
        </div>
      </div>
      <div className="mt-2 pt-2 border-0 border-t border-solid border-gray-200 mb-4">
        <Typography
          className="mb-1"
          variant="overline"
        >
          How Auto-Refill Works
        </Typography>
        <Typography variant="body">
          When you have fewer than 1,000 credits remaining within a billing cycle,
          25,000 credits will automatically be added to your account.
          You’ll be charged $50 plus taxes and fees. Auto-refill credits expire after 32 days.
        </Typography>
      </div>
      <div className="flex justify-end">
        <Button
          className="mr-2"
          data-qa="auto-refill-disable"
          elementType="button"
          onPress={disableAutoTopup}
          variant="text"
        >
          {disableLabel}
        </Button>
        <Button
          data-qa="auto-refill-enable"
          elementType="button"
          onPress={enableAutoTopup}
        >
          {enableLabel}
        </Button>
      </div>
    </Modal>
  );
};

export const CreditsTopupModal = modalConnectV2(
  CREDITS_AUTO_TOPUP_MODAL,
  InternalCreditsTopupModal,
);
